module.exports = __webpack_public_path__ + "media/applicants/device_signup_7-au-b7ac6d2c.webp";